export const SUPERGRAPH_URL_PROD = 'https://www.nerdwallet.com/api/supergraph';
export const SUPERGRAPH_URL_STAGE = 'https://stage.nerdwallet.biz/api/supergraph';
